
document.addEventListener("DOMContentLoaded", function () {
  var coll = document.getElementsByClassName("collapsible-headers");
  for (var i = 0; i < coll.length; i++) {
    coll[i].addEventListener("click", function () {
      for (var j = 0; j < coll.length; j++) {
        if (coll[j] !== this && coll[j].classList.contains("active")) {
          coll[j].classList.remove("active");
          coll[j].nextElementSibling.style.display = "none";
          var indicator = coll[j].querySelector(".indicator");
          indicator.innerHTML = `
            <svg class="h-6 w-6 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
            </svg>
          `;
        }
      }
      this.classList.toggle("active");
      var content = this.nextElementSibling;
      var indicator = this.querySelector(".indicator");
      if (this.classList.contains("active")) {
        indicator.innerHTML = `
          <svg class="h-6 w-6 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M20 12H4"></path>
          </svg>
        `;
        content.style.display = "block";
      } else {
        indicator.innerHTML = `
          <svg class="h-6 w-6 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6v6m0 0v6m0-6h6m-6 0H6"></path>
          </svg>
        `;
        content.style.display = "none";
      }
    });
  }
});

document.addEventListener("DOMContentLoaded", function () {
  const searchIconContainers = document.querySelectorAll(".search-icon-container");
  const searchBarContainers = document.querySelectorAll(".search-bar-container");

  if (!searchIconContainers.length || !searchBarContainers.length) return;

  let lastScrollTop = 0;
  let accumulatedScroll = 0;
  let lastDirection = null;
  const pixelThreshold = 65;

  window.addEventListener("scroll", function () {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const scrollDelta = scrollTop - lastScrollTop;
    const direction = scrollDelta > 0 ? "down" : "up";

    if (direction === lastDirection) {
      accumulatedScroll += Math.abs(scrollDelta);
    } else {
      accumulatedScroll = Math.abs(scrollDelta);
      lastDirection = direction;
    }

    if (accumulatedScroll > pixelThreshold) {
      if (direction === "down") {
        searchIconContainers.forEach(icon => icon.classList.remove("hidden"));
        searchBarContainers.forEach(bar => bar.classList.add("hidden"));
      } else {
        searchIconContainers.forEach(icon => icon.classList.add("hidden"));
        searchBarContainers.forEach(bar => bar.classList.remove("hidden"));
      }

      accumulatedScroll = 0;
    }

    lastScrollTop = scrollTop <= 0 ? 0 : scrollTop;
  });

  searchIconContainers.forEach(iconContainer => {
    iconContainer.addEventListener("click", function () {
      searchIconContainers.forEach(icon => icon.classList.add("hidden"));
      searchBarContainers.forEach(bar => bar.classList.remove("hidden"));
    });
  });
});


document.addEventListener("DOMContentLoaded", function () {
  var myInterval = setInterval(function () {
     var deleteSearchValues = document.querySelectorAll(
      ".search-delete-value-button"
    );
    var searchBar = document.querySelectorAll(".search-bar");
    
    deleteSearchValues.forEach(function (button) {
      button.addEventListener("click", function () {
        searchBar.forEach(function (input) {
          input.value = "";
        });
      });
    });
  }, 1000)
 

  setTimeout(function() { 
    clearInterval(myInterval);
  }, 15000);
});

// card slider js
$('.card_slider_image').slick({
  infinite: true,
  slidesToShow: 1,
  slidesToScroll: 1,
  dots:true,
  prevArrow: '<button class="slick-prev custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="13px" width="13px" version="1.1" id="Layer_1" viewBox="0 0 330 330" xml:space="preserve"> <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/> </svg></button>',
  nextArrow: '<button class="slick-next custom-arrow"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" fill="#000000" height="13px" width="13px" version="1.1" id="Layer_1" viewBox="0 0 330 330" xml:space="preserve"> <path id="XMLID_222_" d="M250.606,154.389l-150-149.996c-5.857-5.858-15.355-5.858-21.213,0.001  c-5.857,5.858-5.857,15.355,0.001,21.213l139.393,139.39L79.393,304.394c-5.857,5.858-5.857,15.355,0.001,21.213  C82.322,328.536,86.161,330,90,330s7.678-1.464,10.607-4.394l149.999-150.004c2.814-2.813,4.394-6.628,4.394-10.606  C255,161.018,253.42,157.202,250.606,154.389z"/> </svg></button>'
});

// addsliders to picture
document.addEventListener('DOMContentLoaded', function () {
  const pictureContainer = document.querySelector('.splide__slide.is-active img')?.parentElement;
  const sliderArrows = document.querySelectorAll('.splide__arrow');
  const bulletPointsContainer = document.querySelector('.splide__pagination');

  // Utility function to set styles
  function setElementStyles(element, styles) {
    if (element && styles) {
      Object.keys(styles).forEach((style) => {
        element.style[style] = styles[style];
      });
    }
  }

  if (pictureContainer) {
    setElementStyles(pictureContainer, {
      position: 'relative',
    });
  }

  if (sliderArrows.length === 2) {
    sliderArrows.forEach((arrow) => {
      // Reduce size by 25% and add padding
      arrow.style.transform = 'scale(0.75)';
      arrow.style.padding = '5px';
    });

    setElementStyles(sliderArrows[0], {
      position: 'absolute',
      top: '50%',
      left: '10px',
      transform: 'translateY(-50%) scale(0.75)',
    });
    setElementStyles(sliderArrows[1], {
      position: 'absolute',
      top: '50%',
      right: '10px',
      transform: 'translateY(-50%) scale(0.75)',
    });
  }

  if (bulletPointsContainer) {
    setElementStyles(bulletPointsContainer, {
      position: 'absolute',
      bottom: '20px', // Raised bullet points
      left: '50%',
      transform: 'translateX(-50%)',
      display: 'flex',
      gap: '5px',
    });
  }
});




